import type { SVGProps } from 'react';

export const Leave = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.40446 3.02669C6.96568 3.61214 7.99998 5.10463 7.99998 6.77201V6.772C7.99998 5.10462 9.03426 3.61214 10.5955 3.02668L16 1V4.2918C16 6.56443 14.7159 8.64201 12.6832 9.65836L8.89995 11.55V14.2H10.2C11.1941 14.2 12 15.0059 12 16H3.99998C3.99998 15.0059 4.80586 14.2 5.79997 14.2H7.09995V11.55L3.31667 9.65836C1.28396 8.64201 -6.10352e-05 6.56442 -6.10352e-05 4.29179V1L5.40446 3.02669Z"
        fill="currentColor"
      />
    </svg>
  );
};
